/** 只接受本次客服请求的稳定错误码及匹配语言的展示消息，不读取聊天业务原文。 */
export function agentServiceBrowserErrorMessage(error) {
  if (!error?.config?.agentServiceLocalizedError) return null;
  const body = error.response?.data;
  if (
    !body ||
    typeof body.errorCode !== "string" ||
    !/^[A-Z][A-Z0-9_]*$/.test(body.errorCode)
  ) {
    return null;
  }
  const requestedLocale = error.config.headers?.["Accept-Language"];
  if (requestedLocale && body.locale !== requestedLocale) return null;
  return typeof body.msg === "string" && body.msg.trim() ? body.msg : null;
}
